// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimsList-cls1_uX9","cls2":"ClaimsList-cls2_Sjn ClaimsList-cls1_uX9"};